import styled from 'styled-components';

/** Block text with the standard gap below it. Bare `<p>`/`<ul>` have no baseline margins in Studio. */
export const Paragraph = styled.p`
    margin: 0 0 16px;
`;

export const BulletedList = styled.ul`
    margin: 0 0 16px;
`;

/** Container for server- or constant-provided HTML, which brings its own `<p>` and `<ul>`. */
export const RichText = styled.div`
    p,
    ul {
        margin: 0 0 16px;
    }
`;
